import { Button } from '@/components/ui/shadcn/button'
import { Upload1Icon } from '@/components/ui/icons/icons-new'

interface Props {
  onClick?: () => void
  disabled?: boolean
  loading?: boolean
  className?: string
  size?: 'default' | 'sm' | 'lg'
}

export const UploadButton = ({
  onClick,
  disabled,
  loading,
  className,
  size = 'default',
}: Props) => {
  return (
    <Button
      variant="secondary"
      onClick={onClick}
      disabled={disabled || loading}
      size={size}
      className={className}>
      <Upload1Icon color="var(--foreground)" />
      {loading ? 'Uploading...' : 'Upload'}
    </Button>
  )
}
